<div class="resultArea" *ngIf="listData.dataSource.data.length > 0">
  <table mat-table [dataSource]="listData.dataSource" matSort (matSortChange)="sortData($event)" matSortDisableClear>
    <ng-container *ngFor="let col of tableColumns;" matColumnDef={{col.columnDef}}>
      <ng-container *ngIf="col.sortable">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ col.header }}</th>
      </ng-container>
      <ng-container *ngIf="!col.sortable">
        <th mat-header-cell *matHeaderCellDef> {{ col.header }}</th>
      </ng-container>
      <td mat-cell *matCellDef="let row; let last = last">
        {{ col.cell(row) }}
      </td>
    </ng-container>
    <ng-container matColumnDef='expandedColumn'>
      <td mat-cell *matCellDef="let row;" [attr.colspan]="'100%'">
        <div class="ex-container">
          <div class="ex-element">
            <span class="ex-desc bold-text">Betreuernummer</span>
            {{ row.data.betreuernummer ? row.data.betreuernummer : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc bold-text ">Polizzenadresse</span>
            {{ row.data.adresse ? (row.data.adresse | formatAdress) : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc bold-text ">Inkassoadresse</span>
            {{ row.data.inkassoAdresse ? (row.data.inkassoAdresse | formatAdress) : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc bold-text ">Ablaufdatum</span>
            {{ row.data.ablaufdatum ? (row.data.ablaufdatum | formatDate) : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc  bold-text">Zuletzt bearbeitet von:</span>
            {{ row.data.bearbeitet.email }}
          </div>
          <div class="ex-element" *ngIf="row.data.kfzkennzeichen">
            <span class="ex-desc  bold-text">Kennzeichen (KFZ)</span>
            {{ row.data.kfzkennzeichen }}
          </div>
          <div class="ex-element" *ngIf="row.data.kaskoVariante">
            <span class="ex-desc  bold-text">Kaskovariante</span>
            {{ row.data.kaskoVariante }}
          </div>
          <div class="ex-element" *ngIf="row.data.selbstbehalt">
            <span class="ex-desc  bold-text">Selbstbehalt</span>
            {{ row.data.selbstbehalt }}
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row;">
        <button mat-icon-button type="button" (click)="toggleExpanded(row)">
          <mat-icon>{{ row.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="aktionen">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let row;">
        <button mat-icon-button type="button" (click)="editPolizze(row.data)"
                matTooltip="Bearbeiten"
                matTooltipClass="tooltip-multiline">

          <mat-icon>create</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="deletePolizze(row.data, 'Schwebebestand löschen')"
                matTooltip="Löschen"
                matTooltipClass="tooltip-multiline">

          <mat-icon>delete</mat-icon>
        </button>
        <button appThrottleEvent mat-icon-button type="button" (throttleEvent)="openInPezi(row.data)"
                [matTooltip]="'Im ' + (userTextService.getCockpitName$() | async) +  ' öffnen'"
                matTooltipClass="tooltip-multiline">

          <mat-icon>developer_board</mat-icon>
        </button>
        @if (userService.isAuthorized$('O30_ERINNERUNG') | async) {
          <app-reminder [polizzeId]="row.data.id" [(reminder)]="row.data.reminder"></app-reminder>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'expanded': row.isExpanded}"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedColumn']; when: isExpansionDetailRow"
        [@detailExpand]="row.isExpanded ? 'expanded' : 'collapsed'"></tr>
  </table>
</div>
<div [ngClass]="listData.dataSource.filteredData.length>20 ? 'custom-pagination' : 'displaynone'">
  <div class="pagination-text">{{ currentPaginationLabel }}</div>
  <mat-paginator class="custom-paginator" (page)="updateLabel()" [hidePageSize]="true" [pageSizeOptions]="[20]"
                 [length]="listData.dataSource.filteredData.length"></mat-paginator>
</div>
<div class="loading-area" *ngIf="listData.dataSource.data.length === 0 || listData.loading">
  <mat-spinner *ngIf="listData.loading" [diameter]="50" strokeWidth="3"></mat-spinner>

  <app-no-data text="Keine Daten gefunden" *ngIf="listData.dataSource.data?.length === 0 && !listData.loading">
  </app-no-data>
</div>
